import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Typography } from '@mui/material';
import { MONTHS } from '../../utils/generalFuncs';
import { AddCircleOutlineRounded, CloudDownloadRounded } from '@mui/icons-material';
import Currency from '../common/Currency';
import SalaryDetails from '../Admin/Salary/SalaryDetails';
import { extension } from 'mime-types'

class EmployeeSalaryList extends Component {
    state = {
        openDetails: false,
        salary: {},

    }
    handleClose = () => {
        this.setState({ 
            openDetails: false,
            salary: {},
        });
    };    
    render() {
        const { SALARIES, employee } = this.props;
        const { openDetails, salary } = this.state;
        return (
            <Box p={2}>
                {openDetails && !isEmpty(salary) && 
                    <SalaryDetails handleClose={this.handleClose} {...this.props} salary={salary} currentEmployee={employee} />
                }
                {/* <Typography variant="h5" id="tableTitle">
                    Liste des Salaires
                </Typography> */}
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Periode</TableCell>
                                {/* <TableCell>Date de Paiement</TableCell> */}
                                <TableCell>Montant</TableCell>
                                <TableCell>Statut</TableCell>
                                <TableCell>Détails</TableCell>
                                <TableCell>Télécharger</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {SALARIES ? Object.values(SALARIES).map( item => (
                                <TableRow key={item.salary_id}>
                                    <TableCell>
                                        {MONTHS[new Date(item.salary_period_end).getMonth()]} {new Date(item.salary_period_end).getFullYear()}
                                    </TableCell>
                                    <TableCell><Currency value={item.salary_to_pay} /></TableCell>
                                    <TableCell>{item.salary_status}</TableCell>
                                    <TableCell>
                                        <IconButton onClick={
                                            () => this.setState({ openDetails: true, salary: item })
                                        }>
                                            <AddCircleOutlineRounded />
                                        </IconButton>
                                    </TableCell>
                                    <TableCell>
                                        {!isEmpty(item.salary_files) &&
                                            <a href={`/photos/single/${item.salary_files[0].filename}`} 
                                                download={`salaire_${MONTHS[new Date(item.salary_period_end).getMonth()]}_${new Date(item.salary_period_end).getFullYear()}.${ extension(item.salary_files[0].filetype) || "pdf"}`}
                                            >
                                                <IconButton >
                                                    <CloudDownloadRounded />
                                                </IconButton>      
                                            </a>
                                        }
                                    </TableCell>
                                </TableRow>
                            )):
                            <Typography variant="button" id="tableTitle">
                                Pas de Salaire pour le moment
                            </Typography>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    }
}

export default EmployeeSalaryList;